import React from 'react';
import { freshness } from '../../utils/freshness';
import type { WikiPageArticle } from '../../types/wiki';

// 出处行。这是 author_kind 那一列**唯一的读者**（spec §17.5.2）——
// 在它存在之前那一列只有写入和校验，而设计文档用「没有读者的列比没有这一列更糟」
// 砍掉过 parent_id / project_id / position，这一行是把同一把尺子用在自己身上。
//
// 它要回答的问题只有一个：这一段是我自己想的，还是 Claude 写的？
const WHO: Record<string, string> = { human: '你改的', agent: 'Claude 改的' };

// 设计稿的出处行是 13px、用淡色的「·」分隔，而「谁改的」比另两段深一档 ——
// 那三段里只有它是**信息**，另两段是坐标。
const Provenance: React.FC<{ page: WikiPageArticle }> = ({ page }) => (
  <span className="flex items-center gap-2 text-[13px] text-todo-muted">
    <span>第 {page.version} 版</span>
    {/* 没有版本记录时不显示作者，而不是显示「未知」—— 后者看起来像出了错。 */}
    {page.author_kind && (
      <>
        <span className="text-todo-line2">·</span>
        <span className="text-todo-ink2">{WHO[page.author_kind] ?? page.author_kind}</span>
      </>
    )}
    <span className="text-todo-line2">·</span>
    <span>更新于 {freshness(page.days_since_update, page.updated_at)}</span>
  </span>
);

export default Provenance;
